<template>
  <div class="activity">
    <div class="banner">
      <div class="periods">
        <span>{{period.period_num}}期</span>
        <span>{{period.period_expire}}</span>
      </div>
      <div class="levitate">
        <p @click="show = !show">活动规则</p>
        <!-- <p @click="callCustomer()">联系客服</p> -->
      </div>
    </div>

    <div class="enroll">
      <div class="button" @click="scroll" v-if="isEnroll == 0">
        <span>立即报名</span>
      </div>
      <div class="button is_enroll" @click="scroll" v-else><span>报名成功</span></div>
    </div>

    <div class="rule block bg">
      <div class="title bg">冲榜单</div>
      <div class="level content">
        <table>
          <thead>
            <th>冲榜名次</th>
            <th>任务要求(累计赚取)</th>
            <th>奖励金额</th>
          </thead>
          <tbody>
            <tr v-for="item in level" :key=item.id>
              <td>{{item.title}}</td>
              <td>{{item.standard_money}}</td>
              <td>{{item.reward_money}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="desc" v-html="rule"/>
    </div>

    <div class="recommend block bg">
      <div class="title bg">推荐游戏</div>
      <div class="games content">
        <div class="data">
          <div class="item" v-for="(item,key) in games" :key="key">
            <div class="icon"><img :src="item.imgurl"/></div>
            <p class="name">{{item.adname}}</p>
            <div class="play" @click="toApp(item.jump_url)">开始赚</div>
          </div>
        </div>
        <div class="more" @click="toApp(more)">查看更多任务 ></div>
      </div>
      <div class="desc" v-html="range"/>
    </div>

    <div class="rank">
      <ul class="tab">
        <li
          class="bg"
          v-for="(item, index, key) in rankConfig" 
          :class="{active: index == currentRankId}"
          :key="key"
          @click="getRank(index)"
        >
          {{index == activityid? '本期': '上期'}}：{{item.begin_date}}-{{item.end_date}}
        </li>
      </ul>
      <div class="billboard block bg">
        <div class="tab_content content">
          <div class="prize_res"><em></em>{{currentRankInfo.status == 1? '已上榜' : '未上榜'}} 奖励领取后将于{{currentRankReward}}发放</div>
          <!-- <div class="theader">
            <span>排名</span>
            <span>用户信息</span>
            <span>活动奖励</span>
          </div> -->
          <div class="list">
            <div class="item_tip">活动奖励</div>
            <div class="item_tip_triangle"></div>
            <div class="item me">
              <div class="row">
                <div class="ranking">{{getMyLevel}}</div>
                <div class="head_pic"><img :src="currentRankInfo.avatar"/></div>
                <div class="info">
                  <div><span style="font-weight: bold;" >{{currentRankInfo.nickname}}</span> <font color="#FF9F1F">(我)</font></div>
                  <div>活动赚取：<font style="color:#FF9F1F; font-weight: 500;">{{currentRankInfo.money}}</font><em :class="{hide: controlShow[currentRankId + '_' + userid]}" @click="getComplete(userid)"></em></div>
                </div>
                <div class="prize receive" v-if="currentRankInfo.status == 1">
                  <span class="grant_money">+{{currentRankInfo.reward_money}}</span>
                  <span @click="receiveGrant" class="prize_btn" v-if="currentRankInfo.grant_status == 1">待领取</span>
                  <span class="prize_btn received" v-if="currentRankInfo.grant_status == 2">审核中</span>
                  <span class="prize_btn received" v-if="currentRankInfo.grant_status == 3">已发放</span>
                </div>
                <div class="prize" v-else>
                  <span class="grant_money">+{{currentRankInfo.reward_money}}</span>
                </div>
              </div>
              <div class="detail" v-if="controlShow[currentRankId + '_' + userid]">
                <div class="task" v-for="(item, key) in task[currentRankId + '_' + userid]" :key=key  @click="toApp(item.jump_url)">
                  <div class="icon"><img :src="item.ad_imgurl"/></div>
                  <div class="task_info">
                    <p>{{item.ad_name}}</p>
                    <p>{{item.reward_money}}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="item"  v-for="(item,key) in data[page.page - 1]" :key=key>
              <div class="row">
                <div class="ranking" :class="{first: item.show_level ==1, second: item.show_level == 2, third: item.show_level == 3}" v-if="item.show_level <= 3"></div>
                <div class="ranking" v-else>{{item.show_level}}</div>
                <div class="head_pic"><img :src="item.avatar" /></div>
                <div class="info">
                  <div><span style="font-weight: bold;" >{{item.nickname}}</span><font color="#FF9F1F" v-if="item.userid == userid">(我)</font></div>
                  <div>活动赚取：<font style="color:#FF9F1F; font-weight: 500;">{{item.integral}}</font><em :class="{hide: controlShow[currentRankId + '_' + item.userid]}" @click="getComplete(item.userid)"></em></div>
                </div>
                <div class="prize"><span class="grant_money">+{{item.reward_money}}</span></div>
              </div>
              <div class="detail" v-if="controlShow[currentRankId + '_' + item.userid]">
                <div class="task" v-for="(item, key) in task[currentRankId + '_' + item.userid]" :key=key @click="toApp(item.jump_url)">
                  <div class="icon"><img :src="item.ad_imgurl"/></div>
                  <div class="task_info">
                    <p>{{item.ad_name}}</p>
                    <p>{{item.reward_money}}</p>
                  </div>
                </div>
              </div>
              <div class="line"></div>
            </div>
          </div>
          <div class="page">
            <div class="page_control">
              <span class="up bg" :class="{disable: !hasBefore}" @click="before()"></span>
              <span class="page_num">{{page.page}}/{{page.total}}</span>
              <span class="down bg" :class="{disable: !hasNext}" @click="next()"></span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <van-popup v-model="show" :close-on-click-overlay=false>
      <div class="introduce block bg">
        <div class="title bg">活动规则</div>
        <div class="rule_info content">
          <div v-html="introduce"></div>
        </div>
      </div>
      <div class="close" @click="show = false"></div>
    </van-popup>

    <loading :isLoad="isLoad"></loading>
  </div>
</template>

<style lang="less" scoped>
.activity {
  display: block;
  width: 100%;
  max-width: 3.75rem;
  min-height: 100vh;
  background-color: #A10239;
  overflow: hidden;

  .block {
    display: block;
    width: 3.43rem;
    margin: 0 auto;
    margin-bottom: .16rem;
    border-radius: .05rem;
    position: relative;
    overflow: hidden;

    .title {
      display: block;
      min-width: 1rem;
      height: .34rem;
      padding: 0 .4rem;
      line-height: .34rem;
      font-size: .16rem;
      font-weight: bold;
      color: #FFFFFF;
      text-align: center;
      position: absolute;
      left:50%;
      transform: translate(-50%, 0);
      z-index: 5;
      overflow: hidden;
    }
    .content {
      display: block;
      width: 3.27rem;
      margin: 0 auto;
      margin-top: .08rem;
      background: #FFFFFF;
      box-shadow: inset 0 .01rem .08rem 0 rgba(47,162,134,0.65);
      border-radius: .05rem;
      overflow: hidden;
    }
    .desc {
      display: block;
      width: 3.03rem;
      margin: 0 auto;
      margin-top: .08rem;
      margin-bottom: .12rem;
      text-align: justify;
      font-size: .12rem;
      color: #FFFFFF;
    }
  }
  .nav {
    display: block;
    width: 100%;
    height: 0.73rem;
    position: fixed;
    top: 0;
    z-index: 100;
    background-color: #A10239;
    overflow: hidden;

    .toback {
      display: block;
      width: .09rem;
      height: .16rem;
      background: url('~@/assets/images/ranking_shouyou/back.png');
      background-size: .09rem .16rem;      
      left: .16rem;
      top: .35rem;
      position: absolute;
    }
    .content {
      display: flex;
      width: 2.93rem;
      height: .73rem;
      margin: 0 auto;
      justify-content: space-around;
      align-items: flex-end;
      position: relative;
      overflow: hidden;

      p {
        width: 1.47rem;
        height: .16rem;
        margin-bottom: .2rem;
      }
      p.shouyou {
        position: relative;
        background: url('~@/assets/images/ranking_shouyou/shouyou_choose.png') no-repeat;
        background-size: .33rem .16rem;
        background-position: center;

        .choose {
          width: .16rem;
          height: .03rem;
          background: #FFEF98;
          border-radius: 0.015rem;
          position: absolute;
          left: 0;
          right: 0;
          bottom: -.13rem;
          margin: auto;
        }
      }
      p.buyu {
        background: url('~@/assets/images/ranking_buyu/buyu.png') no-repeat;
        background-size: .33rem .16rem;
        background-position: center;
      }
      p.yizhi {
        background: url('~@/assets/images/ranking_yizhi/yizhi.png') no-repeat;
        background-size: .33rem .16rem;
        background-position: center;
      }
    }
  }
  .enroll {
    display: block;
    width: 100%;
    overflow: hidden;

    .button {
      display: block;
      width: 2.86rem;
      margin: .14rem auto .1rem auto;
      span {
        display: flex;
        align-items:center;
        justify-content:center;
        height: .52rem;
        font-size: .18rem;
        font-weight: bold;
        text-shadow: 0 .01rem 0 rgba(255,255,255,0.60);
        color: #9E5433;
        letter-spacing: .0225rem;
        background-image: linear-gradient(0deg, #FFB042 0%, #FFF8CB 100%);
        box-shadow: 0 .02rem .08rem 0 #0E684A, inset 0 .02rem .08rem 0 rgba(0,0,0,0.20), inset 0 -.04rem .08rem 0 rgba(255,255,255,0.6);
        border-radius: .27rem;
      }
    }
    .is_enroll {
      span {
        background-image: linear-gradient(0deg, #fecf2b 0%, #fcf1a4 100%);
        box-shadow: 0 .02rem .08rem 0 #0E684A, inset 0 .02rem .08rem 0 rgba(0,0,0,0.20), inset 0 -.04rem .08rem 0 rgba(255,255,255,0.6);
      }
    }
  }
  .rule {
    display: block;
    min-height: 3.17rem;
    margin-top: .08rem;
    overflow: hidden;

    .level {
      display: block;
      min-height: 2.4rem;
      overflow: hidden;

      table {
        width: 3.03rem;
        margin: 0 auto;
        margin-top: .42rem;
        margin-bottom: .16rem;
        border-collapse: collapse;

        th {
          height: .26rem;
          background: #FFE3DB;
          font-size: .12rem;
          color: #4D3533;
          font-weight: normal;
          border: .01rem solid #E6D8D8;
        }
        td {
          height: .26rem;
          background: #FFF5F3;
          text-align: center;
          border: .01rem solid #E6D8D8;
          font-size: .12rem;
          color: #4D3533;
        }
        td:last-child {
          color: #ED2C23;
          font-weight: 500;
        }
      }
    }
  }
  .recommend {
    display: block;
    min-height: 4.06rem;
    overflow: hidden;

    .games {
      display: block;
      min-height: 3.59rem;
      position: relative;
      overflow: hidden;

      .data {
        display: flex;
        width: 100%;
        margin-top: .42rem;
        margin-bottom: .2rem;
        flex-wrap: wrap;
        justify-content: flex-start;        
        overflow: hidden;

        .item {
          display: block;
          width: .62rem;
          margin: 0 0.098rem;
          margin-bottom: .29rem;
          font-size: .12rem;
          overflow: hidden;

          .icon {
            display: block;
            width: .62rem;
            height: .62rem;
            margin-bottom: .06rem;
            overflow: hidden;

            img {
              width: 100%;
              border-radius: .1rem;
            }
          }
          .name {
            white-space:nowrap;
            text-overflow:ellipsis;
            text-align: center;
            margin-bottom: .06rem;
            overflow: hidden;
          }
          .play {
            display: block;
            width: .62rem;
            height: .26rem;
            text-align: center;
            line-height: .26rem;
            background: #FF7F4B;
            border-radius: .13rem;
            color: #ffffff;
            overflow: hidden;
          }
        }
      }
      .more {
        display: block;
        width: 3.21rem;
        height: .36rem;
        margin: 0 auto;
        font-size: .12rem;
        color: #4D3533;
        text-align: center;
        line-height: .36rem;
        background: #FFF5F3;
        border-radius: 0 0 .06rem .06rem;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, 0);
        overflow: hidden;
      }
    }
  }
  .rank {
    display: block;
    // min-height: 8.59rem;
    position: relative;
    overflow: hidden;

    .tab {
      display: flex;
      width: 3.43rem;
      height: .6rem;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      margin: auto;
      justify-content: space-between;
      overflow: hidden;
      border-radius: .08rem .08rem 0 0;

      li {
        display: block;
        width: 1.72rem;
        height: .6rem;
        font-size: .14rem;
        color: #FFFFFF;
        line-height: .6rem;
        text-align: center;
        border-radius: .08rem .08rem 0 0;
        opacity: 0.5;
        z-index: 1;
        overflow: hidden;
      }
      .active {
        opacity: 1;
        z-index: 3;
      }
    }
    .billboard {
      display: block;
      margin-top: .52rem;
      z-index: 2;
      overflow: hidden;
      
      .tab_content {
        display: block;
        min-height: 7.95rem;
        margin-bottom: .08rem;
        position: relative;
        overflow: hidden;

        .prize_res {
            display: flex;
            width: 2.6rem;
            height: .28rem;
            line-height: .28rem;
            font-size: .12rem;
            color: #7A1C1C;
            background: #FFF5F3;
            margin: .16rem auto;
            border-radius: .14rem;
            align-items: center;
            justify-content: center;
            white-space: nowrap;
            overflow: hidden;

            em {
              display: inline-block;
              width: .11rem;
              height: .15rem;
              background: url('~@/assets/images/ranking_shouyou/prize_lose.png');
              background-size: .11rem .15rem;
              margin-right: .08rem;
              overflow: hidden;
            }
        }
        .theader {
          display: block;
          width: 100%;
          height: .42rem;
          font-size: .14rem;
          color: #333333;
          line-height: .42rem;
          overflow: hidden;

          span:first-child {
            margin-left: .12rem;
          }
          span:nth-child(2) {
            margin-left: .62rem;
          }
          span:last-child {
            margin-right: .12rem;
            float: right;
          }
        }
        .list {
          position: relative;
          display: block;
          width: 100%;
          height: auto;
          margin-bottom: .42rem;
          overflow: hidden;
          .item_tip {
            position: absolute;
            top: 0;
            right: .16rem;
            font-size: .12rem;
            color: #fff;
            background: #FF4733;
            height: .18rem;
            height: .18rem;
            padding: 0 .04rem;
            border-radius: .03rem;
          }
          .item_tip_triangle {
            position: absolute;
            top: .18rem;
            right: .55rem;
            display:block;
            width:0;
            height:0;
            border:.04rem solid transparent;  //所有border都是透明的，
            border-top-color: #FF4733; //只有尖相对的方向border有颜色
          }

          .item {
            display: block;
            clear: both;
            width: 3.21rem;
            margin: 0 auto;
            min-height: .62rem;
            background: #FFFFFF;
            overflow: hidden;

            .row {
              display: flex;
              width: 100%;
              height: .62rem;
              align-items: center;
              justify-content: flex-start;
              overflow: hidden;

              .ranking {
                display: block;
                min-width: .28rem;
                height: .24rem;
                text-align: center;
                line-height: .24rem;
                margin-right: .13rem;
                margin-left: .12rem;
                font-size: .14rem;
                font-weight: 550;
                color: #333333;
                overflow: hidden;
              }
              .first {
                display: block;
                width: .24rem;
                height: .24rem;
                background: url('~@/assets/images/ranking_shouyou/rank_first.png') no-repeat;
                background-size: .24rem .24rem;
                background-position: center;
                overflow: hidden;
              }
              .second {
                display: block;
                width: .24rem;
                height: .24rem;
                background: url('~@/assets/images/ranking_shouyou/rank_second.png') no-repeat;
                background-size: .24rem .24rem;
                background-position: center;
                overflow: hidden;
              }
              .third {
                display: block;
                width: .24rem;
                height: .24rem;
                background: url('~@/assets/images/ranking_shouyou/rank_third.png') no-repeat;
                background-size: .24rem .24rem;
                background-position: center;
                overflow: hidden;
              }
              .head_pic {
                display: block;
                width: .34rem;
                height: .34rem;
                border-radius: 100%;
                background: #000;
                margin-right: .12rem;
                overflow: hidden;

                img {
                  width: 100%;
                }
              }
              .info {
                display: flex;
                height: .34rem;
                font-size: .12rem;
                flex-direction: column;
                justify-content: space-between;

                div:last-child {
                  color: #998E8D;
                  
                  em {
                    display: inline-block;
                    width: .11rem;
                    height: .06rem;
                    margin-left: .04rem;
                    background: url('~@/assets/images/ranking_shouyou/control_display.png');
                    background-size: .11rem .06rem;
                    overflow: hidden;
                  }
                  .hide {                    
                    transform:rotate(180deg);
                  }
                }
              }
              .prize {
                display: flex;
                margin-left: auto;
                margin-right: .12rem;
                align-items: center;
                overflow-y: hidden;

                .grant_money {
                  height: .18rem;
                  line-height: .18rem;
                  font-size: .16rem;
                  font-weight: bold;
                  text-align: right;
                  color: #FF4733;
                }
              }
              .receive {
                flex-direction: column;
                justify-content: space-around;
                align-items: flex-end;

                .prize_btn {
                  display: block;
                  width: .5rem;
                  height: .22rem;
                  border-radius: .12rem;
                  background-color: #FF4B1F;
                  line-height: .22rem;
                  text-align: center;
                  color: #fff;
                }
                .prize_btn.received {
                  border: .01rem solid #FF7F4B;
                  width: .48rem;
                  height: .2rem;
                  color: #FF7F4B;
                  background-color: transparent;
                }
              }
            }
            .detail {
              display: flex;
              float: right;
              width: 2.15rem;
              margin-bottom: .04rem;
              margin-right: .12rem;
              flex-wrap: wrap;
              justify-content: space-between;

              .task {
                display: block;
                width: 1rem;
                height: .3rem;
                margin-bottom: .12rem;
                overflow: hidden;

                .icon {
                  display: block;
                  float: left;
                  width: .3rem;
                  height: .3rem;
                  border-radius: .05rem;
                  overflow: hidden;

                  img {
                    width: 100%;
                    border-radius: .05rem;
                  }
                }
                .task_info {
                  display: flex;
                  float: right;
                  margin-left: .08rem;
                  width: .62rem;
                  height: .3rem;
                  flex-direction: column;
                  justify-content: space-around;
                  white-space:nowrap;
                  overflow: hidden;

                  p {
                    display: block;
                    width: .62rem;
                    height: .15rem;
                    line-height: .15rem;
                    font-size: .12rem;
                    white-space:nowrap;
                    text-overflow:ellipsis;
                    overflow: hidden;
                  }
                  p:first-child {
                    color: #999999;
                  }
                  p:last-child {
                    color: #333333;
                  }
                }
              }
            }
            .line {
              display: block;
              float: right;
              width: 2.55rem;
              border-top: .01rem rgb(250, 250, 250) solid;
              margin-right: .12rem;
            }
          }
          .me {
            // height: .7rem;
            background: #FFF5F3;

            .row {
              height: .7rem;

              .prize {
                height: .42rem;
              }
            }
          }
        }
        .page {
          display: flex;
          width: 3.21rem;
          height: .42rem;
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translate(-50%, 0);
          background: #FFF5F3;
          border-radius: 0 0 .06rem .06rem;
          align-items: center;
          overflow: hidden;

          .page_control {
            display: flex;
            width: 2.72rem;
            height: .25rem;
            margin: 0 auto;
            justify-content: space-between;
            align-items: center;
            overflow: hidden;

            .page_num {
              font-size: .14rem;
            }
            .up {
              display: block;
              width: .25rem;
              height: .25rem;
              overflow: hidden;
            }
            .down {
              display: block;
              width: .25rem;
              height: .25rem;
              overflow: hidden;
            }
            .up.disable {
              display: block;
              width: .25rem;
              height: .25rem;
              overflow: hidden;
            }
            .down.disable {
              display: block;
              width: .25rem;
              height: .25rem;
              overflow: hidden;
            }
          }
        }
      }
    }
  }
  .introduce {
    display: block;
    min-height: 3.66rem;
    margin-bottom: 0;
    overflow: hidden;

    .rule_info {
      display: block;
      min-height: 3.5rem;
      margin-bottom: .08rem;
      overflow: hidden;

      div:first-child {
        display: block;
        width: 2.79rem;
        margin: 0 auto;
        margin-top: .5rem;
        margin-bottom: .24rem;
        font-size: .14rem;
        text-align: justify;
        overflow: hidden;
      }
    }
  }
  /deep/.van-popup {
    background: transparent;

    .close {
      display: block;
      width: .32rem;
      height: .32rem;
      background: url('~@/assets/images/ranking_shouyou/close.png') no-repeat;
      background-size: .32rem .32rem;
      margin: 0 auto;
      margin-top: .24rem;
      overflow: hidden;
    }
  }
}
</style>

<script>
import Vue from 'vue';
import { Popup, Toast } from 'vant';
import Loading from '@/components/Loading'

Vue.use(Popup).use(Toast);

export default {
  created() {
    this.userid = this.getCookie('userid')
    this.deviceid = this.getCookie('device_id')
    this.appVersion = this.getCookie('app_version')
    if (this.$route.query.debug == 1) {
      this.userid = this.$route.query.userid
      this.deviceid = this.$route.query.device_id
      this.appVersion = this.$route.query.app_version
    }

    this.getData()
  },
  components: {
    Loading
  },
  props: {
    group: String,
    rule: String,
    range: String
  },
  data() {
    return {
      userid: '',
      deviceid: '',
      appVersion: '',
      activityid: 0,
      activityDate: '',
      level: [],
      games: [],
      more: '',
      show: false,
      isLoad: false,
      introduce: '',
      rankConfig: {},
      currentRankId: 0,
      rankData: {},
      pageData: {},
      task: {},
      data: [],
      page: {},
      controlShow: {},
      myRankLevel: {},
      currentRankInfo: {},
      rewardTime: {},
      currentRankReward: '',
      period: {},
      isEnroll: 0,
      isReceive: true
    }
  },
  methods: {
    getCookie: function (name) {
      var strcookie = document.cookie; //获取cookie字符串
      var arrcookie = strcookie.split("; "); //分割
      //遍历匹配
      for (var i = 0; i < arrcookie.length; i++) {
        var arr = arrcookie[i].split("=");
        if (arr[0] == name) {
          return arr[1];
        }
      }
      return ""
    },
    callClienFunc: function(fname, fval) {
      if (window.hasOwnProperty('injectedObject')) {
        window.injectedObject.setJsContent(fname, fval)
      } else {
        fval = fval? fval : {}
        let params = {method: fname, params:fval}
        params = JSON.stringify(params)
        window.Android.postMessage(params)
      }
    },
    receiveGrant: function() {
      const params = {
        activity_id: this.currentRankId,
        userid: this.userid
      }
      this.$http.get('/api/user_web/receive_grant', {params: params}).then(() => {
        window.location.reload()
      })
    },
    before: function () {
      this.page.page = this.page.page - 1 >= 1? this.page.page - 1 : 1
    },
    next: function () {
      this.page.page = this.page.page + 1 <= this.page.total? this.page.page + 1 : this.page.total
    },
    scroll: function () {
      if (this.isEnroll != 1) {
        this.report()
        this.isEnroll = 1
        Toast("报名成功")
        setTimeout(1000)
      }
      document.body.scrollTop = 600
    },
    toApp: function(url) {
      window.location.href = url
    },
    goBack: function() {
      this.callClienFunc('closeWebview', '')
    },
    callCustomer: function () {
      //window.location.href = 'http://game.ahaozhuan.com/web/h5/#/strategy3'
      window.location.href = 'lezhuan://jump?type=48&content={"source":"3"}'
    },
    getRank(rankId) {
      this.currentRankId = rankId
      if (this.rankData.hasOwnProperty(this.currentRankId)) {
        this.data = this.rankData[this.currentRankId]
        this.page = this.pageData[this.currentRankId]
        this.currentRankInfo = this.myRankLevel[this.currentRankId]
        this.currentRankReward = this.rewardTime[this.currentRankId]
        return
      }
      
      let params = {
        activity_id: this.currentRankId,
        app_version: this.appVersion,
        userid:this.userid,
        device_id: this.deviceid,
      }

      this.isLoad = true
      this.$http.get('/api/user_web/show_activity', {params: params}).then((res) => {
        let data = res.data.list
        Object.keys(data).forEach((key) => {
          if (data[key].itemCategory != 'item_data_month' && data[key].itemCategory != 'item_my' && data[key].itemCategory != 'item_time') {
            delete data[key]
          }
        })
        
        this.setItem(data)
        this.isLoad = false
      })
    },
    getData() {
      let params = {
        group_name: this.group,
        app_version: this.appVersion,
        userid:this.userid,
        device_id: this.deviceid,
      }
      this.isLoad = true
      this.$http.get('/api/user_web/show_activity_month', {params: params}).then((res) => {
        Object.keys(res.data.list).forEach((key) => {
          if (res.data.list[key].itemCategory == 'item_time') {
            this.activityid = res.data.list[key].activity_id
            this.currentRankId = res.data.list[key].activity_id
            this.isEnroll = res.data.list[key].is_enroll
          }
        })
        
        this.setItem(res.data.list)
        this.isLoad = false
      })
    },
    setItem: function (config) {
      Object.keys(config).forEach((key) => {
        switch(true) {
          // 试玩排名说明
          case config[key].itemCategory == 'item_top':
            this.level = config[key].item_list
            break
          // 推荐游戏
          case config[key].itemCategory == 'item_recommend_ad':
            this.games = config[key].recommend_ad
            break
          // 查看更多跳转链接
          case config[key].itemCategory == 'item_recommend':
            this.more = config[key].jump_url
            break
          // 奖励规则说明
          case config[key].itemCategory == 'item_popup':
            this.introduce = this.htmlspecialcharsDecode(config[key].reward_rule_txt)
            break
          // 榜单数据配置
          case config[key].itemCategory == 'item_data_month':
            this.$set(this.pageData, config[key].activity_id, {page: 1, total: parseInt(config[key].page_count)})
            this.$set(this.rankData, config[key].activity_id, config[key].item_list)
            break
          // 榜单相关配置
          case config[key].itemCategory == 'item_stage':
            if (config[key].item_stage.hasOwnProperty('current_activity')) {
              this.$set(this.rankConfig, config[key].item_stage.current_activity.activity_id, config[key].item_stage.current_activity)
              this.currentRankId = config[key].item_stage.current_activity.activity_id
            }

            if (config[key].item_stage.hasOwnProperty('up_activity')) {
              this.$set(this.rankConfig, config[key].item_stage.up_activity.activity_id, config[key].item_stage.up_activity)
            }
            break
          // 我的上榜记录
          case config[key].itemCategory == 'item_my':
            var grantStatus = 0
            if (config[key].my_level.is_receive == 2) {
              grantStatus = 1 // 待领取
            } else if (config[key].my_level.is_receive == 1 && config[key].my_level.grant_state == 1) {
              grantStatus = 2 // 审核中
            } else if (config[key].my_level.is_receive == 1 && config[key].my_level.grant_state == 2)  {
              grantStatus = 3 // 已发放
            }
            
            this.$set(this.myRankLevel, config[key].activity_id, {
              avatar: config[key].avatar,
              reward_money: config[key].my_level.reward_money,
              money: config[key].my_level.integral,
              status: config[key].my_level.is_upward == 0? 0 : 1,
              nickname: config[key].nickname,
              level: config[key].my_level.current_level,
              grant_status: grantStatus
            })
            break
          // 活动及其榜单时间
          case config[key].itemCategory == 'item_time':
            if (config[key].activity_id == this.activityid) {
              this.$set(this.period, 'period_num', config[key].activity_stage)
              this.$set(this.period, 'period_expire', config[key].activitySpan_time)
            }

            this.$set(this.rewardTime, config[key].activity_id, config[key].award_prizes_time)
            break
        }
      })
      
      this.data = this.rankData[this.currentRankId]
      this.page = this.pageData[this.currentRankId]
      this.currentRankInfo = this.myRankLevel[this.currentRankId]
      this.currentRankReward = this.rewardTime[this.currentRankId]
    },
    getComplete: function(userid) {
      this.setShowStatus(userid)
      let id = this.currentRankId + '_' + userid

      // 如果是关闭状态停止运行
      if (false === this.controlShow[id]) {
        return
      }
      
      if (this.task.hasOwnProperty(id)) {
        return
      }

      let params = {
        activity_id: this.currentRankId,
        app_version: this.appVersion,
        play_userid:userid,
        userid: this.userid,
        device_id: this.deviceid,
      }
      this.isLoad = true
      this.$http.get('/api/user_web/show_activity_ad', {params: params}).then((res) => {
        let data = res.data
        this.$set(this.task, id, data)
        this.isLoad = false
      })
    },
    setShowStatus: function (userid) {
      let key = this.currentRankId + '_' + userid
      if (!this.controlShow.hasOwnProperty(key)) {
        this.$set(this.controlShow, key, true)
      } else {
        this.$set(this.controlShow, key, !this.controlShow[key])
      }
    },
    htmlspecialcharsDecode: function (str){  
      var s = "";
      if(str.length == 0) return "";
      s = str.replace(/&amp;/g,"&");
      s = s.replace(/&lt;/g,"<");
      s = s.replace(/&gt;/g,">");
      s = s.replace(/&nbsp;/g," ");
      return s;  
    },
    report: function() {
      let params = {
        userid: this.userid,
        activity_id: this.activityid
      }

      this.$http.get('/api/user_web/activity_report', {params: params})
    }
  },
  computed: {
    hasBefore: function () {
      return this.page.page == 1? false : true
    },
    hasNext: function () {
      return this.page.page == this.page.total? false : true
    },
    getMyLevel: function () {
      return this.currentRankInfo.status == 1? this.currentRankInfo.level : '99+'
    }
  }
}
</script>